"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
const pino_1 = __importDefault(require("pino"));
const config_1 = require("./config");
const logger = () => (0, pino_1.default)({
    browser: {
        transmit: {
            send: (_, logEvent) => __awaiter(void 0, void 0, void 0, function* () {
                var _a, _b, _c;
                const config = (0, config_1.getConfig)();
                (_a = config === null || config === void 0 ? void 0 : config.onLog) === null || _a === void 0 ? void 0 : _a.call(config, logEvent);
                try {
                    yield fetch(`${(_b = config === null || config === void 0 ? void 0 : config.basePath) !== null && _b !== void 0 ? _b : ''}${(_c = config === null || config === void 0 ? void 0 : config.apiPath) !== null && _c !== void 0 ? _c : '/api/logger'}`, {
                        method: 'POST',
                        headers: { 'content-type': 'application/json' },
                        body: JSON.stringify(
                        // Hackily massage messages from exceptions into being { err: {...} } to normalize how logging looks
                        errorifyMessages(logEvent)),
                    });
                }
                catch (e) {
                    console.warn(e);
                    console.warn('Unable to log to backend', logEvent);
                }
            }),
        },
    },
});
exports.logger = logger;
function errorifyMessages(logEvent) {
    logEvent.messages = logEvent.messages.map((message) => {
        var _a;
        if (typeof message === 'object' && 'stack' in message) {
            return {
                err: {
                    type: message.type,
                    stack: message.stack,
                    message: (_a = message.msg) !== null && _a !== void 0 ? _a : message.message,
                },
            };
        }
        return message;
    });
    return logEvent;
}
